import { Component, OnInit } from '@angular/core';
import { TableService } from '@pg-app/partner/dashboard/components/table/table.service';
import { format } from 'date-fns';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { DATE_FORMAT_POST } from '../constants/date-time-constants';

@Component({
  selector: 'np-table-traded-account',
  templateUrl: './traded-account.component.html'
})
export class TableTradedAccountComponent implements OnInit {
  public rows: Array<any> = [];
  columns = [
    {
      title: 'Client name',
      name: 'clientName',
      width: '170px'
    },
    {
      title: 'Expected transaction size',
      name: 'expectedTransactionSize',
      width: '150px'
    },
    {
      title: 'Referral date',
      name: 'dateReferred',
      type: TableCellTypes.Date,
      width: '170px'
    },
    {
      title: 'Date account open',
      name: 'dateAccountOpen',
      type: TableCellTypes.Date,
      width: '170px'
    },
    {
      title: 'Date last traded',
      name: 'dateTraded',
      sort: 'desc',
      type: TableCellTypes.Date,
      width: '170px'
    },
    {
      title: 'Referral to account open',
      name: 'referredToAccountOpen',
      width: '170px'
    },
    {
      title: 'Referral to last traded',
      name: 'referredToTrade',
      width: '170px'
    }
  ];

  constructor(private tableService: TableService) { }

  ngOnInit() {
    this.getTableData();
  }

  public getTableData() {
    const now = new Date();
    const month = now.getMonth();
    const year = now.getFullYear();

    const start = new Date(year, month, 1);
    const end = new Date(year, month + 1, 0);

    const tableData = {
      getAll: true,
      fromDate: format(start, DATE_FORMAT_POST),
      toDate: format(end, DATE_FORMAT_POST)
    };

    this.tableService.getTableTradeAccountData(tableData).subscribe(
      data => {
          this.rows = data || [];
      },
    );
  }
}
